export default __webpack_public_path__ + "static/media/payroll-feature-tax-mgt.90af45ef.svg";